import * as React from 'react';
import getHtmlDataSet from 'Utils/GetHtmlDataSet';
import postData from 'Utils/PostData';

// Assets

// Components

export default class InstructorProfileButton extends React.Component<{}, {}> {
    private setUserMode(mode) {
        postData(
            '/user/switch-mode/?format=json',
            {
                new_mode: mode
            },
            'application/x-www-form-urlencoded')
            .then(() => { window.location.reload() })
            .catch(err => console.error(err));
    }

    public render() {
        return <li className='nav-item dropdown'>
            <a
                className='nav-link dropdown-toggle'
                href='#'
                id='navbarDropdown'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'>
                {getHtmlDataSet().fullName}
            </a>
            <div className='dropdown-menu' aria-labelledby='navbarDropdown'>
                {/* {getHtmlDataSet().isInstructor === 'True' ? (
                    getHtmlDataSet().mode === 'I' ?
                        <a className='dropdown-item' href='#' onClick={() => this.setUserMode('S')}>View as Student</a>
                        :
                        <a className='dropdown-item' href='#' onClick={() => this.setUserMode('I')}>View as Instructor</a>
                ):null} */}
                <a className='dropdown-item' href='#'>Profile</a>
                <div className='dropdown-divider'></div>
                <a className='dropdown-item' href='/accounts/logout/'>Sign Out</a>
            </div>
      </li>
    }
};
